import { toValue } from 'vue'
import { email, maxLength, minLength, minValue, maxValue, numeric, required, sameAs } from '@vuelidate/validators'
import { maxDate, minDate, validIban, externalValidation } from '@/utils/validators'
import { isValidDate } from '@/utils/utils'
import { get as _get, has as _has, isObject as _isObject } from 'lodash'

const VALIDATOR_TYPES = {
  productRequired: 'required',
  terms: 'sameAs',
  minAmount: 'minValue'
}

const VUELIDATE_VALIDATORS_MAP = {
  required: () => ({ required: v => _isObject(v) ? Object.values(v).some(v => v) : required.$validator(v) }),
  email: () => ({ email }),
  numeric: () => ({ numeric }),
  iban: () => ({ iban: validIban }),
  minLength: ({ value }) => ({ minLength: minLength(value) }),
  maxLength: ({ value }) => ({ maxLength: maxLength(value) }),
  minDate: ({ value }) => isValidDate(value) ? { minDate: minDate(new Date(value)) } : {},
  maxDate: ({ value }) => isValidDate(value) ? { maxDate: maxDate(new Date(value)) } : {},
  external: ({ value }) => ({ external: externalValidation(value) }),
  minValue: ({ validator, value }) => ({ [validator]: minValue(value) }),
  maxValue: ({ value }) => ({ maxValue: maxValue(value) }),
  sameAs: ({ validator, value }) => ({ [validator]: value === 'true' || value === 'false' ? sameAs(Boolean(value)) : sameAs(value) })
}

export function useVuelidateValidation () {
  const getValidationArg = ({ validator, value }) => {
    if (!validator) return {}

    const key = VALIDATOR_TYPES[validator] || validator

    return VUELIDATE_VALIDATORS_MAP[key]?.({ validator, value }) ?? {}
  }

  const getValidationArgs = ({ validations = [], data = {} }) => {
    const validations_value = toValue(validations)

    if (!Array.isArray(validations_value)) return validations_value

    return validations_value
      .filter(arg => typeof arg === 'string')
      .reduce((args, arg) => {
        let [validator, value] = arg.split(/:(.*)/)

        if (value && _has(toValue(data), value.split('.')[0])) value = _get(toValue(data), value)

        return { ...args, ...getValidationArg({ validator, value }) }
      }, {})
  }

  return {
    getValidationArgs
  }
}